// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"14c44f9e","130":"5b70be9c","377":"78615433","382":"e7798a35","464":"46dae7f6","650":"5a7b135b","875":"ab9aa4c9","939":"81fe37f3","950":"ad6ae6f6"}[chunkId] + ".chunk.js";
};